import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'app/core/services/language.service';
import { IdentityService } from 'app/services/authentication/identity.service';
import { CookieService } from 'ngx-cookie-service';
import { catchError, map, Observable, of } from 'rxjs';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrl: './language-dropdown.component.scss'
})
export class LanguageDropdownComponent implements OnInit {

  public defaultLangs = [
    "es-ar", "en-us"
  ];

  countryName: any;
  cookieValue: any;
  textValue: any;
  valueset: any;
  /***
   * Language Listing
   */
  listLang = [
    { text: 'EN', flag: 'assets/images/flags/us.svg', lang: 'en-us' },
    { text: 'ES', flag: 'assets/images/flags/spain.svg', lang: 'es-ar' },
    // { text: 'Deutsche', flag: 'assets/images/flags/germany.svg', lang: 'de' },
    // { text: 'Italiana', flag: 'assets/images/flags/italy.svg', lang: 'it' },
    // { text: 'русский', flag: 'assets/images/flags/russia.svg', lang: 'ru' },
    // { text: '中国人', flag: 'assets/images/flags/china.svg', lang: 'ch' },
    // { text: 'français', flag: 'assets/images/flags/french.svg', lang: 'fr' },
    // { text: 'Arabic', flag: 'assets/images/flags/ar.svg', lang: 'ar' },
  ];

  constructor(
    public _translateService: TranslateService,
    private _identityService: IdentityService,
    public _cookiesService: CookieService,
    public languageService: LanguageService,
    private _httpClient: HttpClient,
  ) { }

  ngOnInit(): void {
    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.textValue === undefined) { this.valueset = 'EN'; }
    } else {
      this.textValue = val.map(element => element.text);
    }
  }

  /***
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.textValue = text;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
    this._translateService.use(lang);
    this._identityService.defaultLanguage = lang;
    const iframes = document.getElementsByTagName('iframe');
    for (let index = 0; index < iframes.length; index++) {
      const iframe = iframes.item(index);
      if (iframe && iframe.contentWindow && iframe.src.includes('external')) {
        iframe.contentWindow.postMessage({
          setLanguage: lang
        }, '*');
      }
    }
  }

  setLanguageSettings() {
    if (this._identityService.defaultLanguage) {
      if (this.translateFileExists(this._identityService.defaultLanguage)) {

        this._translateService.setDefaultLang(
          this._identityService.defaultLanguage
        );

        let languageIndex = this.defaultLangs.findIndex((language) => {
          return language.substr(0, 2) === this._identityService.defaultLanguage.substr(0, 2)
        });

        this.defaultLangs[languageIndex] = this._identityService.defaultLanguage;
      } else {
        let defaultLanguage = this.defaultLangs.find((language) => {
          return language.substr(0, 2) === this._identityService.defaultLanguage.substr(0, 2)
        });

        this._identityService.defaultLanguage = defaultLanguage;
        this._translateService.setDefaultLang(defaultLanguage);
      }
    } else {
      let userLang: string = navigator.language || (navigator as any).userLanguage;
      let defaultLanguage = this.defaultLangs.find((language) => {
        return language.substr(0, 2) === userLang.substr(0, 2)
      });

      this._identityService.defaultLanguage = defaultLanguage;
      this._translateService.setDefaultLang(defaultLanguage);
    }

    this._translateService.addLangs(this.defaultLangs);
    this._translateService.use(this._identityService.defaultLanguage);
  }

  translateFileExists(languageCode: string): Observable<boolean> {
    return this._httpClient.get(`./assets/i18n/${languageCode}.json`)
      .pipe(
        map(response => {
          return true;
        }),
        catchError(err => {
          return of(false);
        }))
  }
}
